<template>
  <Dialog
    header="Conta em periodo de Teste"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="false"
  >
    <p style="text-align: justify">
      Sua conta está em periodo de teste até o dia
      {{ $formatDate(this.account.dueDate) }}. Após a data será necessário
      regularizar o pagamento para continuar com o acesso liberado.
    </p>
    <template #footer>
      <Button
        label="Fechar"
        class="p-button-success"
        @click="$emit('update:visible', false)"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'AccountWarningTrial',
  props: {
    visible: Boolean,
    account: Object,
  },
};
</script>


<style scoped>
</style>